import ShopInvoices from "../symbols/shopInvoices";
import { HttpRequestPost } from "../../service";
const deliveryAcceptAction = () => ({
  type: ShopInvoices.SHOP_INVOICES,
});
const deliveryAcceptSuccessAction = (data: any) => ({
  type: ShopInvoices.SHOP_INVOICES_SUCCESS,
  payload: data,
});
const deliveryAcceptFailureAction = (data: any) => ({
  type: ShopInvoices.SHOP_INVOICES_FAILURE,
  payload: data,
});
const clearShopInvoicesAction = () => ({
  type: ShopInvoices.CLEAR_SHOP_INVOICES,
});

export function getShopInvoices(
  Page: number,
  Size: number,
  DateFrom: string | null,
  DateTo: string | null,
  OrderId: Array<string> | null,
  DeliveryId: string | null,
  Query: string | null,
  InvoiceType: any,
) {
  return (dispatch: any) => {
    dispatch(deliveryAcceptAction());
    HttpRequestPost(
      `/shop/invoices`,
      dispatch,
      deliveryAcceptSuccessAction,
      deliveryAcceptFailureAction,
      true,
      {
        Page: Page || 0,
        Size: Size || 10,
        Query,
        Filter: { DateFrom, DateTo, OrderId, DeliveryId, InvoiceType },
      }
    );
  };
}

export function clearShopInvoices() {
  return (dispatch: any) => {
    dispatch(clearShopInvoicesAction());
  };
}
